import React from 'react'

import MediaItem from '@/components/media-item'
import RichText from '@/components/rich-text'
import {Layout} from '@/styles/grid'

import type {Props as MediaItemProps} from '@/components/media-item'
import type {Props as RichTextProps} from '@/components/rich-text'
import type {LayoutProps} from '@/styles/grid'

import * as s from './title-with-media-items.styles'

export interface Props {
    title: RichTextProps['content']
    items: MediaItemProps[]
    variant?: Extract<LayoutProps['$variant'], 'two-equal' | 'three-equal'>
    dataTestId?: string
}

const TitleWithMediaItemsSection = ({title, items, variant = 'two-equal', dataTestId}: Props) => {
    const threeColProps = {
        titleVariant: 'paragraph-large',
        direction: 'vertical',
        bodyProps: {
            $variant: 'paragraph-base',
        },
    } as const

    const twoColProps = {
        titleVariant: 'title-base',
        direction: 'horizontal',
        bodyProps: {
            $variant: 'paragraph-large',
        },
    } as const

    const itemProps = variant === 'three-equal' ? threeColProps : twoColProps

    return (
        <s.Wrapper data-testid={dataTestId}>
            <Layout $variant="two-asymmetrical">
                <RichText $variant="heading-base" forwardedAs="h2" content={title} />
            </Layout>

            <s.Items
                $variant={variant}
                {...(dataTestId && {'data-testid': `${dataTestId}-item-container`})}
            >
                {items.map((item, i) => (
                    <MediaItem {...item} {...itemProps} key={`${item.title}-${i}`} />
                ))}
            </s.Items>
        </s.Wrapper>
    )
}

export default TitleWithMediaItemsSection
